module.exports = __webpack_public_path__ + "static/media/zhongniuhushan_mobile.44972fca.webp";